<div class="branding">
    <app-container>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-row justify-start items-center">
            <mat-form-field appearance="outline" floatLabel="always" class="form-group max-w-[49%] w-full" required>
                <mat-label>{{ "locationName" | translate }}</mat-label>
                <input matInput class="form-control" formControlName="locName" autocomplete="off">
            </mat-form-field>
            <div>
            <button mat-raised-button color="primary" (click)="onSubmit()" type="submit"
                class="ml-20 flex items-center" [disabled]="form.valid == false">{{ "update" | translate }}</button>
                <ng-container *ngIf="form.controls['locName'].invalid && form.pristine == false">
                <mat-error *ngIf="form.controls['locName'].errors.required" class="ml-20 mt-10">
                    {{ "required" | translate }}
                  </mat-error>
                </ng-container>
                </div>
        </form>
        <div class="flex flex-col md:flex-row gap-5" >
            <div class="w-1/2" [style.display]="logoSiteOption ? 'block' : 'none'">
                <div>
                    <h3 class="p-15">{{ "logoUpload" | translate }}</h3>
                </div>
                <mat-card>
                    <app-client-logo></app-client-logo>
                    <app-image-cropper type="siteLogo"></app-image-cropper>
                </mat-card>
            </div>
            <div class="w-1/2" [style.display]="logoReportOption ? 'block' : 'none'">
                <div>
                    <h3 class="p-15">{{ "reportUpload" | translate }}</h3>
                </div>
                <mat-card>
                    <app-report-logo></app-report-logo>
                    <app-image-cropper [type]="'reportLogo'"></app-image-cropper>
                </mat-card>
            </div>
        </div>
    </app-container>
</div>